import axios from 'axios'
import router from './router'

function GetQueryString (name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

// axios 配置
axios.defaults.timeout = 120000;
axios.defaults.baseURL =  process.env.VUE_APP_BASE_URL
axios.defaults.headers.post['Content-Type'] = 'application/json'

// if(GetQueryString('token')) {
//   axios.defaults.headers.token = GetQueryString('token')
// }

// http request 拦截器
axios.interceptors.request.use(
  config => {
    return config;
  },
  err => {
    return Promise.reject(err);
  });

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 401 清除token信息并跳转到登录页面
          // store.commit(types.LOGOUT);
          router.replace({
            path: 'login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          })
      }
    }
    return Promise.reject(error.response.data)
  });

let http = {
  get: function(url, params) {
    return new Promise((resolve, reject) => {
      axios.get(url, {
        params
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  post: function(url, data) {
    return new Promise((resolve, reject) => {
      axios.post(url, data)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  }
}

export default http
